module.exports = __webpack_public_path__ + "static/media/20.a8725fc5.JPG";